import React from 'react';
import CheckBox from '../../checkBox/CheckBox';
import _ from 'lodash';
import VirtualServiceTypeIcon from '../../../icons/VirtualServiceTypeIcon';
import { TransactionType } from '../../../../types/rest/assetCatalogTypes';

export interface TypeFilterSelection {
  http: boolean;
  messaging: boolean;
}

interface Props {
  handleChange: (value: TransactionType) => void;
  selected: TypeFilterSelection;
}

const TypeFilter = (props: Props) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
        <span className={'ml-3'}>Type:</span>
        <span
          className={'ml-4 hand-cursor'}
          onClick={() => props.handleChange('HTTP')}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <CheckBox style={{ marginRight: '0px' }} checked={props.selected.http} onCheck={_.noop} />
          <VirtualServiceTypeIcon type={'HTTP'} className={'mr-2 align-middle'} />
          <span>HTTP</span>
        </span>
        <span
          className={'ml-5 hand-cursor'}
          onClick={() => props.handleChange('MESSAGING')}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <CheckBox style={{ marginRight: '0px' }} checked={props.selected.messaging} onCheck={_.noop} />
          <VirtualServiceTypeIcon type={'MESSAGING'} className={'mr-2 align-middle'} /> <span>MESSAGING</span>
        </span>
      </div>
    </div>
  );
};

export default TypeFilter;
